import { render, staticRenderFns } from "./LoginError.vue?vue&type=template&id=47a250d1"
import script from "./LoginError.vue?vue&type=script&setup=true&lang=ts"
export * from "./LoginError.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports